import React, { useMemo } from 'react';
import { Dropdown } from '../dropdown/Dropdown';
import { CSSObjectWithLabel } from 'react-select';
import { useTranslation } from 'react-i18next';

interface ICustomReportTypeDropdown {
  value: string | null;
  label: string;
}

export enum CUSTOM_REPORT_TYPE {
  STATIC = '0',
  RECURRING = '1',
}

type Props = {
  onDropdownChangeHandler: (value: string) => void;
  selectedTypeOption: string | null;
  extendStyles?: {
    container?: CSSObjectWithLabel;
    menu?: CSSObjectWithLabel;
    control?: CSSObjectWithLabel;
    menuList?: CSSObjectWithLabel;
    valueContainer?: CSSObjectWithLabel;
    input?: CSSObjectWithLabel;
  };
};

export const CustomReportTypeDropdown = ({
  onDropdownChangeHandler,
  selectedTypeOption,
  extendStyles,
}: Props) => {
  const { t } = useTranslation();

  const dropdownTypeOptions: ICustomReportTypeDropdown[] = useMemo(
    () => [
      { value: null, label: t('All') },
      { value: CUSTOM_REPORT_TYPE.STATIC, label: t('Static') },
      { value: CUSTOM_REPORT_TYPE.RECURRING, label: t('Recurring') },
    ],
    [t]
  );
  return (
    <Dropdown
      extendStyles={extendStyles}
      menuPortalTarget={document.body}
      zIndexProp={1}
      menuPlacement={'bottom'}
      height={40}
      creatable={false}
      className='dropdown'
      placeholder={t('Type')}
      value={dropdownTypeOptions.find(
        option => option.value === selectedTypeOption && !!selectedTypeOption
      )}
      onChange={value => onDropdownChangeHandler(value.value)}
      options={dropdownTypeOptions}
    />
  );
};
